import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

function Resources() {
    const [resourcesRef, isResourcesVisible] = useScrollAnimation({ threshold: 0.15 });

    return (
        <div className="bg-[#f3f3f3] pb-4 pt-20 font-ui min-h-screen">
            <div
                ref={resourcesRef}
                className={`max-w-7xl mx-auto px-5 py-10 bg-white rounded-[20px] p-12 m-12 lg:p-16 shadow-sm transition-all duration-1000 ease-out transform ${isResourcesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}
            >
                <h1 className={`text-center text-3xl font-bold text-gray-800 mb-10 font-ui transition-all duration-1000 ease-out transform ${isResourcesVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                    }`}>
                    Resources
                </h1>
                <div className="flex flex-col items-center justify-center">
                    <p className="text-left text-gray-600 mb-10 font-ui">
                        Under construction.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default Resources;